<div class="login-page">

  <div class="login-card">

    <div class="login-box">

      <img class="logo" src="assets/img/emdr logo monochrome white.svg" alt="EMDR therapy logo"/>


      <form class="form-body" [formGroup]="ResetPasswordForm" (ngSubmit)="reset()" autocomplete="new-password">

        <div class="upper-login">
          <div class ="inp">
            <input type="password" name="email" formControlName="newPassword" placeholder="New Password" id="username" autocomplete="new-password" required>
          </div>  
          <div class ="inp">
            <input type="password" name="email" formControlName="confPassword" placeholder="Confirm Password" id="username" autocomplete="new-password" required>
          </div>
        </div>

        <div class="lower-login">

          <div class="login-error" *ngIf="passError">{{passError}}</div>
          <div class="success" *ngIf="successMsg">{{successMsg}}</div>
          <button id="Connect" mat-raised-button color="darkGreen" type="submit" >Reset</button>
        </div>
      </form>
    </div>  

      <div class="emdr">
        @2021EMDRremote
      </div>

  </div>

</div>
